export default __webpack_public_path__ + "static/media/facebook-logo.3fdd1cc4.svg";